export default "__VITE_ASSET__PRUfiC2$__"